export const baseUrl = process.env.NODE_ENV === "production" ? "https://api.epiclivewallpapers.com/api" : "https://api.epiclivewallpapers.com/api"

// https://api.epiclivewallpapers.com/api